module.exports = __webpack_public_path__ + "public/img/fruits.fe3b5b38.png";